import React from "react";
import Seo from "@/components/Seo";
import { CtaBand, FaqBlock, PageHero, RelatedLinks } from "@/components/Shared";
import { IMG } from "@/lib/site";

const crumbs = [
  { label: "Startseite", to: "/" },
  { label: "FAQ", to: "/faq" },
];

export const GLOBAL_FAQ = [
  {
    q: "Was umfasst der Winterdienst?",
    a: "Unser Winterdienst umfasst die Schneeräumung von Gehwegen, Zufahrten, Höfen und Parkflächen, das Streuen von Salz oder Sand gegen Glätte sowie die Beseitigung von Eis an Treppen und in Eingangsbereichen. Auf Absprache kommt der Abtransport größerer Schneemengen hinzu.",
  },
  {
    q: "Bieten Sie Winterdienst für Privatkunden an?",
    a: "Ja. Wir betreuen Einfamilien-, Reihen- und Doppelhäuser, Grundstücke mit langer Zufahrt sowie kleinere Wohnanlagen. Sie legen den Umfang fest – zum Beispiel nur Gehweg und Eingang oder zusätzlich Einfahrt und Garagenvorplatz.",
  },
  {
    q: "Bieten Sie Winterdienst für Gewerbekunden an?",
    a: "Ja. Für Unternehmen räumen und streuen wir Parkplätze, Betriebshöfe, Zufahrten, Rampen, Gehwege und Eingangsbereiche. Grundlage ist ein abgestimmter Räum- und Streuplan mit Prioritäten und Zeitfenstern.",
  },
  {
    q: "Was gehört zur Schneeräumung?",
    a: "Das Räumen der vereinbarten Flächen auf nutzbarer Breite, das Entfernen verdichteter Schneewälle an Einfahrten und die Ablage des Schnees auf einer vorab festgelegten Lagerfläche, die keine Stellplätze, Gullys oder Fluchtwege blockiert. Bei anhaltendem Schneefall räumen wir nach.",
  },
  {
    q: "Bieten Sie Streudienst an?",
    a: "Ja, der Streudienst ist ein eigener Leistungsbereich. Wir verwenden auftauende Mittel auf Fahrflächen und Rampen und abstumpfende Mittel wie Sand oder Granulat auf empfindlichen Belägen und in der Nähe von Bepflanzung.",
  },
  {
    q: "Können Parkplätze geräumt werden?",
    a: "Ja. Wir räumen Kundenparkplätze, Mitarbeiterstellflächen, Parkdecks und Parkhausebenen. Wichtig ist eine vorab definierte Schneelagerfläche; bei großen Mengen ist Abtransport auf Absprache möglich.",
  },
  {
    q: "Können Zufahrten geräumt werden?",
    a: "Ja. Einfahrten, Hofzufahrten, Tiefgaragenrampen und Lkw-Zufahrten gehören zu unseren Leistungen. Gefällestrecken werden intensiver gestreut, weil Fahrzeuge dort anfahren und bremsen.",
  },
  {
    q: "Wie kann ich Winterdienst anfragen?",
    a: "Am schnellsten telefonisch unter +49 421 16152637 oder per WhatsApp an dieselbe Nummer. Alternativ per E-Mail an info@bremer-schneemann.de. Nennen Sie Adresse, Objektart und die Flächen, um die es geht.",
  },
  {
    q: "Sind kurzfristige Einsätze möglich?",
    a: "Einzeleinsätze sind nach Verfügbarkeit möglich, zum Beispiel nach starkem Schneefall oder während einer Abwesenheit. Eine Bereitschaftszusage setzt eine Saisonvereinbarung voraus.",
  },
  {
    q: "In welchem Gebiet bieten Sie Winterdienst an?",
    a: "Im gesamten Bremer Stadtgebiet mit allen Stadtteilen sowie im direkt angrenzenden Umland. Ob ein Objekt außerhalb des Stadtgebiets betreut werden kann, hängt von Lage und Tourenplanung ab – wir geben Ihnen dazu eine offene Einschätzung.",
  },
  {
    q: "Was kostet der Winterdienst?",
    a: "Das richtet sich nach Flächengröße, Leistungsumfang, Belag und Erreichbarkeit. Wir nennen keine Listenpreise, sondern erstellen ein objektbezogenes Angebot auf Anfrage.",
  },
  {
    q: "Erhalte ich einen Nachweis über die Einsätze?",
    a: "Auf Wunsch dokumentieren wir jeden Einsatz mit Datum, Uhrzeit und ausgeführter Leistung. Das ist besonders für Hausverwaltungen, Eigentümer und Gewerbebetriebe relevant.",
  },
];

const FaqPage = () => (
  <main data-testid="page-faq">
    <Seo
      title="FAQ Winterdienst Bremen | Häufige Fragen | Bremer Schneemann"
      description="Häufige Fragen zum Winterdienst in Bremen: Leistungsumfang, Privat und Gewerbe, Schneeräumung, Streudienst, Parkplätze, Zufahrten, Einsatzgebiet und Anfrage."
      path="/faq"
      breadcrumbs={crumbs}
      faq={GLOBAL_FAQ}
      image={IMG.snowyCars}
    />
    <PageHero
      label="/ FAQ"
      titleLines={["Häufige Fragen", "zum Winterdienst", "in Bremen."]}
      intro="Antworten zu Leistungsumfang, Ablauf, Einsatzgebiet und Anfrage – realistisch formuliert, ohne Versprechen, die wir nicht halten können."
      image={IMG.snowyCars}
      breadcrumbs={crumbs}
    />


    <FaqBlock items={GLOBAL_FAQ} title="Alle Fragen und Antworten" label="/ Übersicht" />
    <CtaBand />
    <RelatedLinks
      title="Vielleicht suchen Sie das"
      items={[
        { title: "Winterdienst Bremen", to: "/winterdienst-bremen", desc: "Leistungsbild im Überblick." },
        { title: "Winterdienst Privat", to: "/winterdienst-bremen-privat", desc: "Gehweg, Eingang, Einfahrt." },
        { title: "Winterdienst Gewerbe", to: "/winterdienst-bremen-gewerbe-hausverwaltung", desc: "Parkplätze und Betriebsflächen." },
        { title: "Streudienst Bremen", to: "/streudienst-bremen", desc: "Glättebekämpfung." },
        { title: "Einsatzgebiet", to: "/einsatzgebiet", desc: "Stadtteile und Umland." },
        { title: "Kontakt", to: "/kontakt", desc: "Telefon, WhatsApp, E-Mail." },
      ]}
    />
  </main>
);

export default FaqPage;
